import { FetchResult, useMutation } from '@apollo/client';

import { isDemoEnvironment } from '../../../../constants/global';
import { handleGql403 } from '../../../../utils';
import { MakeAllNotificationsReadMutation, MakeAllNotificationsReadMutationVariables } from '../../types';
import { GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER } from '../useGetUnreadNotificationsCount/getUnreadNotificationsCount';
import { MARK_AS_READ } from './markAllNotificationsAsRead';

type Props = {
  markAllAsRead: (userId: string) => Promise<FetchResult<MakeAllNotificationsReadMutation>>;
  loading: boolean;
};

const useMarkAllNotificationsAsRead = (userId: string): Props => {
  const [makeAllNotificationsRead, { loading }] = useMutation<
    MakeAllNotificationsReadMutation,
    MakeAllNotificationsReadMutationVariables
  >(MARK_AS_READ, {
    update(cache, { data, errors }) {
      if (!errors && data?.makeAllNotificationsRead === null && !isDemoEnvironment) {
        const existingCount = cache.readQuery({
          query: GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER,
          variables: { userId },
        });
        if (existingCount) {
          cache.writeQuery({
            query: GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER,
            variables: { userId },
            data: {
              getNotificationsByUser: {
                total: 0,
                __typename: 'NotificationCount',
              },
            },
          });
        }
      }
    },
  });

  const handleMarkAllAsRead = async (id: string): Promise<FetchResult<MakeAllNotificationsReadMutation>> => {
    if (isDemoEnvironment) return Promise.resolve({});
    return makeAllNotificationsRead({
      variables: {
        userId,
      },
      onError: handleGql403,
    });
  };

  return {
    markAllAsRead: handleMarkAllAsRead,
    loading,
  };
};

export default useMarkAllNotificationsAsRead;
